<template>
  <b-modal class="modal modal-confirm bg-body" id="ModalFormOperasi" size="xl">
    <template #modal-title>
      <h4 class="mb-0 text-left">Ubah Biaya Operasi</h4>
    </template>
    <div class="container-fluid">
      <Alert
        v-if="saveFailed"
        :alert="{
          type: 'danger',
          title: 'Tidak Dapat Menyimpan Data',
          content:
            'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan. Pastikan tidak ada nilai negatif pada biaya',
        }"
      />
      <Alert
        v-if="saveSuccess"
        :alert="{
          type: 'success',
          title: 'Berhasil Menyimpan Data',
          content: 'Penyimpanan data berhasil dilakukan',
        }"
      />
      <FormRowInline
        v-for="row in costForm"
        v-bind:key="row.colnum + String(Math.random(1023))"
        :row="row"
        @handleChange="(e) => handleChange(e)"
        @handleBlur="(e) => handleBlur(e)"
      />
      <div class="row mt-4">
        <div class="col-md-6">
          <h4>Total Tagihan</h4>
        </div>
        <div class="col-md-6">
          <h4 class="text-primary text-right">
            {{ convertToRupiah(total_tagihan) }}
          </h4>
        </div>
      </div>
      <!--/form-->
    </div>
    <template #modal-footer>
      <div class="w-100">
        <button
          class="btn btn-primary float-right"
          @click="
            () => {
              handleForm();
            }
          "
        >
          SIMPAN
        </button>
        <button
          type="button"
          class="btn btn-outline-primary mr-3 float-right"
          @click="$bvModal.hide('ModalFormOperasi')"
        >
          BATAL
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
// @ is an alias to /src
// import Navbar from "@/components/Navbar.vue";
// import Sidebar from "@/components/Sidebar.vue";
// import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRowInline from "@/components/FormRowInline.vue";
// import IntroOperasi from "@/components/IntroOperasi.vue";
import Alert from "@/components/Alert.vue";
import { setOperationIntro, convertToRupiah } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { dataOperasi, costForm, costConstant } from "@/data/OperasiForm.js";
export default {
  name: "ModalFormOperasi",
  components: {
    // Navbar,
    // Sidebar,
    // PageContentHeader,
    FormRowInline,
    Alert,
    // IntroOperasi,
  },
  props: {
    no_rawat: String,
    id_operasi: Number,
    id_ralan: Number,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: dataOperasi,
      detailTop: null,
      costForm: costForm,
      operasiBiaya: null,
      // introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      ralan: {},
      operasi: {},
      id_biaya: null,
      total_tagihan: 0,
      formSet: {
        id: null,
        id_operasi: null,
        jenis_paket_operasi: 0,
        jasa_dokter_operator: 0,
        jasa_dokter_anestesi: 0,
        // jasa_dokter_referal: 0,
        jasa_perawat_anestesi: 0,
        jasa_instrumentator: 0,
        jasa_perawat_sirkuler: 0,
        sewa_kamar_operasi: 0,
        pemberian_obat_dan_alat_kesehatan: 0,
        biaya_lain_lain: 0,
      },
      saveSuccess: false,
      saveFailed: false,
      convertToRupiah: convertToRupiah,
    };
  },
  methods: {
    showModal() {
      this.$bvModal.show("ModalFormOperasi");
    },
    hideModal() {
      this.$bvModal.hide("ModalFormOperasi");
    },
    handleForm: async function(callback) {
      this.errors = [];
      let formData = new FormData();
      let body = "";
      var self = this;
      //console.log(this.formSet);
      let valid = this.validateForm();
      if (valid) {
        formData.append("total_tagihan", this.total_tagihan);
        body += `total_tagihan=${this.total_tagihan}`;
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, parseInt(self.formSet[key]));
          body += `&${key}=${parseInt(self.formSet[key])}`;
        });
        try {
          let result;
          //console.log('Id Biaya: '+this.id_biaya);
          if (this.id_biaya) {
            result = await this.$store.state.HTTP_ENC.put(
              "operasi_biaya/" + this.id_biaya,
              body
            );
          } else {
            result = await this.$store.state.HTTP.post(
              "operasi_biaya",
              formData
            );
          }
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              // that.$router.push(`/ralan/detail/${that.$route.params.id}`);
              that.$emit("onSave");
              that.hideModal();
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
        let that = this;
        this.saveFailed = true;
        this.saveSuccess = false;
        setTimeout(function() {
          that.saveFailed = false;
        }, 1000);
        // this.checkSuccess();
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = parseInt(e.target.value);
      }
      //console.log(this.formSet[e.target.name]);
      // this.updateTotalTagihan();
    },
    updateTotalTagihan() {
      this.total_tagihan =
        this.formSet.jenis_paket_operasi +
        this.formSet.jasa_dokter_operator +
        this.formSet.jasa_dokter_anestesi +
        // this.formSet.jasa_dokter_referal +
        this.formSet.jasa_perawat_anestesi +
        this.formSet.jasa_instrumentator +
        this.formSet.jasa_perawat_sirkuler +
        this.formSet.sewa_kamar_operasi +
        this.formSet.pemberian_obat_dan_alat_kesehatan +
        this.formSet.biaya_lain_lain;
      this.updateForm();
    },
    handleBlur(e) {
      //console.log(e);
      this.total_tagihan =
        this.formSet.jenis_paket_operasi +
        this.formSet.jasa_dokter_operator +
        this.formSet.jasa_dokter_anestesi +
        // this.formSet.jasa_dokter_referal +
        this.formSet.jasa_perawat_anestesi +
        this.formSet.jasa_instrumentator +
        this.formSet.jasa_perawat_sirkuler +
        this.formSet.sewa_kamar_operasi +
        this.formSet.pemberian_obat_dan_alat_kesehatan +
        this.formSet.biaya_lain_lain;
      this.updateForm();
    },
    fetchLaporan: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_laporan?id_operasi=${this.id_operasi}`
      );
      //console.log('data laporan');
      //console.log(result);
      //console.log(result.data);
      //console.log(result.data.data);
      //console.log('data laporan');

      if (result.data.data.length) {
        let nSirkuler = 0;
        this.id_laporan = result.data.data[0].id;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_laporan/${this.id_laporan}`
        );
        //console.log(result2);
        this.operasiLaporan = result2.data;
        // if(this.operasiLaporan.operasi_laporan_perawat_sirkuler && this.operasiLaporan.operasi_laporan_perawat_sirkuler.length){
        //   nSirkuler = this.operasiLaporan.operasi_laporan_perawat_sirkuler.length;
        // }
        nSirkuler =
          (this.operasiLaporan.id_perawat_sirkuler_1 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_2 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_3 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_4 ? 1 : 0) +
          (this.operasiLaporan.id_perawat_sirkuler_5 ? 1 : 0);
        this.formSet.jasa_perawat_sirkuler = nSirkuler * costConstant.sirkuler;
        //console.log(this.operasiLaporan.operasi_laporan_perawat_sirkuler);
        this.costForm[6].columns[0].label = `Jasa Perawat Sirkuler (${nSirkuler} orang)`;
        this.costForm[6].columns[0].additional = `${nSirkuler} x ${costConstant.sirkuler_formatted}`;
        // this.updateForm();
        this.updateTotalTagihan();
      }
    },
    fetchTindakan: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi_tindakan?id_operasi=${this.id_operasi}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          this.formSet["jenis_paket_operasi"] = 0;
          result.data.data.forEach((item) => {
            self.formSet["jenis_paket_operasi"] += item.biaya;
          });
          this.updateTotalTagihan();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchObat: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi_obat?id_operasi=${this.id_operasi}`
        );
        let self = this;
        //console.log(result);
        if (result.status == "200") {
          this.formSet["pemberian_obat_dan_alat_kesehatan"] = 0;
          result.data.data.forEach((item) => {
            self.formSet["pemberian_obat_dan_alat_kesehatan"] += item.sub_total;
          });
          this.updateTotalTagihan();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.costForm = this.costForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else if (
            [
              "number",
              "money",
              "addon-right",
              "addon-left",
              "percentage",
            ].indexOf(column.type) > -1 &&
            !column.negativeValue &&
            parseInt(self.formSet[column.name]) < 0
          ) {
            valid = false;
            column.error = "Nilai yang diisi tidak boleh negatif";
          } else {
            if (column.regex) {
              //console.log(column.regex);
              if (String(self.formSet[column.name] || "").match(column.regex)) {
                column.error = "";
              } else {
                column.error = column.regexError;
                valid = false;
              }
            } else {
              column.error = "";
            }
          }
          if (self.formSet[column.name]) {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      //console.log(this.costForm);
      return valid;
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_biaya?id_operasi=${this.id_operasi}`
      );
      //console.log(result);
      //console.log(result.data);
      //console.log(result.data.data);
      if (result.data.data.length) {
        this.id_biaya = result.data.data[0].id;
        let self = this;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_biaya/${this.id_biaya}`
        );
        //console.log(result2);
        this.operasiBiaya = result2.data;
        Object.keys(this.formSet).forEach(function(key) {
          self.formSet[key] = self.operasiBiaya[key];
        });
        // this.updateForm();
        this.updateTotalTagihan();
      } else {
        this.formSet["jasa_dokter_operator"] = costConstant.operator;
        this.formSet["jasa_dokter_anestesi"] = costConstant.anestesi;
        // this.formSet["jasa_dokter_referal"] = costConstant.referal;
        this.formSet["jasa_perawat_anestesi"] = costConstant.perawat_anestesi;
        this.formSet["jasa_instrumentator"] = costConstant.instrumentator;
        this.formSet["sewa_kamar_operasi"] = costConstant.kamar;
        this.formSet["biaya_lain_lain"] = costConstant.lain;
        this.updateForm();
        //this.updateTotalTagihan();
        // this.formSet['pemberian_obat_dan_alat_kesehatan']
        // this.formSet['jenis_paket_operasi']
        // this.formSet['jasa_perawat_sirkuler']=costConstant.sirkuler*1;
        await this.fetchLaporan();
        await this.fetchTindakan();
        await this.fetchObat();
      }
    },
    updateForm() {
      let self = this;
      this.costForm = this.costForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            (self.formSet[column.name] &&
              self.formSet[column.name] != null &&
              self.formSet[column.name] != "null") ||
            self.formSet[column.name] == 0
          ) {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      //console.log(this.costForm);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.formSet["id_operasi"] = this.id_operasi;
    this.steps = [
      {
        link: `/operasi/form-laporan/${this.id_operasi_ralan}/${this.id_operasi}`,
        label: "Laporan Operasi",
      },
      {
        link: `/operasi/form-tindakan/${this.id_operasi_ralan}/${this.id_operasi}`,
        label: "Tindakan Operasi",
      },
      {
        link: `/operasi/form-obat/${this.id_operasi_ralan}/${this.id_operasi}`,
        label: "Obat dan Alat Kesehatan",
      },
      {
        link: `/operasi/form-biaya/${this.id_operasi_ralan}/${this.id_operasi}`,
        label: "Detail Biaya",
        active: true,
      },
    ];
    try {
      let result = await this.$store.state.HTTP.get(
        `operasi/${this.id_operasi}`
      );
      //console.log(result);
      if (result.status == 200) {
        this.operasi = result.data;
        let result2 = await this.$store.state.HTTP.get(
          `ralan/${this.id_ralan}`
        );
        this.ralan = result2.data;
        // this.introRalanOperasi = setOperationIntro(this.ralan, this.operasi);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    await this.fetchData();
  },
};
</script>
